<template>
    <center> 
     <br v-if="!isMobile"> 
         <b-row class="justify-content-center"> 
             <b-col cols="11" md="7" lg="11" xl="11"> 
                <template> 
                    <center> 
                      <a target="_blank" href="https://convencioncomercial.com.mx/img/RESULTADOS CONVENCION MARZO JULIO 2025.xlsx" @click="guardaDescarga()">
                        <img src="img/resultado.png" class="rounded" alt="Image" :style="isMobile ? 'width:50%;' : 'width:15%; cursor:pointer;'">
                      </a>
                      <br v-if="!isMobile"> <br v-if="!isMobile"> 
                        <b-row class="justify-content-center">
                            <b-col cols="10" md="5" >  
                                <b-row class="justify-content-center" style=" margin: 5px; margin-left: -10px;" v-if="user.canal == 1"> 
                                  <b-col cols="10" md="4" class="mt-5"> 
                                     <img src="elementos/retails/lider.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:115%; cursor:pointer;'"  @click="cambiaRankinR1(3)">  
                                  </b-col>   
                                </b-row>  
                                <b-row class="justify-content-center" style=" margin: 5px; margin-left: -10px;" v-if="user.canal == 4">
                                  <b-col cols="10" md="4" class="mt-5">  
                                    <img src="elementos/especialista/distribuidores.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'" @click="cambiaRankinE1(1)"> 
                                  </b-col>
                                  <b-col cols="10" md="4" class="mt-5">  
                                    <img src="elementos/especialista/kams.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'" @click="cambiaRankinE1(2)"> 
                                  </b-col>
                                  <b-col cols="10" md="4" class="mt-5"> 
                                     <img src="elementos/especialista/lider_e.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'"  @click="cambiaRankinE1(3)">  
                                  </b-col>   
                                </b-row> 
                                <b-row class="justify-content-center" style=" margin: 5px; margin-left: -10px;" v-if="user.canal == 3">
                                  <!-- <b-col cols="10" md="4" class="mt-5">  
                                    <img src="elementos/propios/ejecutivo.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'" @click="cambiaRankinP1(1)"> 
                                  </b-col> -->
                                  <b-col cols="10" md="4" class="mt-5">  
                                    <img src="elementos/propios/puntos.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'" @click="cambiaRankinP1(2)"> 
                                  </b-col>
                                  <b-col cols="10" md="4" class="mt-5"> 
                                     <img src="elementos/propios/lider2.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'"  @click="cambiaRankinP1(3)">  
                                  </b-col>   
                                </b-row>  
                            </b-col> 
                        </b-row>
                        <template v-if="menu_rankin > 0"> 
                          <template v-if="rankin_sub != ''" >
                            <template v-if="rankin_sub == 'especialista_distribuidor1'">
                               <ImgRankinE1 :rankin_sub="rankin_sub"></ImgRankinE1>
                            </template>
                            <template v-if="rankin_sub == 'especialista_kams2'">
                               <ImgRankinE2 :rankin_sub="rankin_sub"></ImgRankinE2>
                            </template>
                            <template v-if="rankin_sub == 'especialista_lider2'">
                               <ImgRankinE3 :rankin_sub="rankin_sub"></ImgRankinE3>
                            </template>
                            <template v-if="rankin_sub == 'retail_lider2'">
                              <ImgRankin :rankin_sub="rankin_sub"></ImgRankin>
                            </template>
                            <template v-if="rankin_sub == 'propio_gerente2'">
                               <ImgRankinP1 :rankin_sub="rankin_sub"></ImgRankinP1>
                            </template>
                            <template v-if="rankin_sub == 'propio_lider2'">
                              <ImgRankinP2 :rankin_sub="rankin_sub"></ImgRankinP2>
                            </template>
                            <!-- <template v-if="isMobile">
                              <br><br>
                              <img :src="'ranking/' + rankin_sub + '_movil.png'" class="rounded mt-5" alt="Image"    style="width:100%;" >
                            </template>
                            <template v-else>
                              <br><br><br><br>
                               <div data-aos="zoom-in" data-aos-delay="250"     data-aos-duration="200"     data-aos-offset="200"> 
                                <img :src="'ranking/' + rankin_sub + '.png'" class="rounded mt-5" alt="Image"    style="width:55%;" >
                               </div>
                              <br><br>
                            </template>   -->
                          </template>
                          <template v-else>
                            <template v-if="isMobile">
                              <img :src="'ranking/imagen_vacia_movil.png'" class="rounded mt-5" alt="Image"  style="width:100%;" >
                            </template>
                            <template v-else>
                              <img :src="'ranking/espacio_vacio_ranking.png'" class="rounded mt-5" alt="Image"  style="width:60%;" >
                            </template> 
                            <!-- <br v-if="!isMobile"><br v-if="!isMobile"><br v-if="!isMobile"><br v-if="!isMobile"><br v-if="!isMobile"><br v-if="!isMobile">
                            <br v-if="!isMobile"><br v-if="!isMobile"><br v-if="!isMobile"><br v-if="!isMobile"><br v-if="!isMobile"><br v-if="!isMobile"> -->
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="isMobile">  
                               <div data-aos="zoom-in" data-aos-delay="450"     data-aos-duration="500" > 
                                 <img src="img/descrubre_1.png" class="rounded"  alt="Image" style="width:95%; "> 
                              </div>
                              <div data-aos="zoom-in" data-aos-delay="650"     data-aos-duration="700" > 
                                 <img src="img/quienes.png" class="rounded"  alt="Image" style="width:95%;  margin-top:-40px;"> 
                              </div>
                              <div data-aos="zoom-in" data-aos-delay="750"     data-aos-duration="800"> 
                                <img src="img/elmeromero.png" :class="anima == 0 ? 'rounded' : 'rounded zoom-in-out-box '" alt="Image" style="width:95%;  margin-top:-20px;">  <br>
                              </div>
                              <div data-aos="zoom-in" data-aos-delay="850"     data-aos-duration="900"> 
                                <img src="img/orgullomexa.png" class="rounded"  alt="Image" style="width:60%;  margin-top:-20px;"> 
                              </div>
                              <br v-if="isMobile"> <br v-if="isMobile">
                          </template>
                          <template v-else>   
                            <br v-if="!isMobile">
                              <div data-aos="zoom-in" data-aos-delay="450"     data-aos-duration="500" > 
                                 <img src="img/descrubre_1.png" class="rounded"  alt="Image" style="width:45%; "> 
                              </div>
                              <div data-aos="zoom-in" data-aos-delay="650"     data-aos-duration="700" > 
                                 <img src="img/quienes.png" class="rounded"  alt="Image" style="width:45%;  margin-top:-80px;"> 
                              </div>
                              <div data-aos="zoom-in" data-aos-delay="750"     data-aos-duration="800">
                                <img src="img/elmeromero.png" :class="anima == 0 ? 'rounded' : 'rounded zoom-in-out-box '"  alt="Image" style="width:45%;  margin-top:-70px;">  <br>
                              </div>
                              <div data-aos="zoom-in" data-aos-delay="850"     data-aos-duration="900"> 
                                <img src="img/orgullomexa.png" class="rounded"  alt="Image" style="width:20%;  margin-top:-30px;"> 
                              </div>
                               <br v-if="!isMobile"> <br v-if="!isMobile">
                          </template> 
                        </template>  
                    </center>  
                </template> 
                      <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:55px; margin-top:-250px;" v-if="!isMobile"> 
                      <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:1455px; margin-top:-650px;" v-if="!isMobile">  
                      <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:1225px; margin-top:-50px;" v-if="!isMobile">   
             </b-col>
          </b-row>
</center>
</template>

<script>
import ImgRankin from './ImgRankin.vue'; 
import ImgRankinE1 from './ImgRankinE1.vue'; 
import ImgRankinE2 from './ImgRankinE2.vue'; 
import ImgRankinE3 from './ImgRankinE3.vue'; 
import ImgRankinP1 from './ImgRankinP1.vue'; 
import ImgRankinP2 from './ImgRankinP2.vue'; 
export default {
  name: 'Ranking', 
  components: { 
    ImgRankin,
    ImgRankinE1,
    ImgRankinE2,
    ImgRankinE3,
    ImgRankinP1,
    ImgRankinP2
  },
  data(){
     return{
         menu_rankin:0,
         rankin_sub:"",
         isMobile: this.$mobile(),
         anima:0
     }
  },
  computed: {
    user() {
      return this.$store.getters.getInfoUser;
    }
  },
  methods:{
    cambiaRankinR1(id){
      this.menu_rankin = id;
      this.rankin_sub = 'retail_lider2';
      this.apibitacora(1);
      this.$bus.$emit("cambi_fo61", true)
    },
    cambiaRankinE1(id){
      this.menu_rankin = id;
      if (id == 1) {
        this.rankin_sub = 'especialista_distribuidor1';  
        this.apibitacora(2);
      }else if(id == 2){
        this.rankin_sub = 'especialista_kams2';  
        this.apibitacora(3);
      }else{
        this.rankin_sub = 'especialista_lider2';  
        this.apibitacora(4);
      }
      
      this.$bus.$emit("cambi_fo61", true)
    },
    cambiaRankinP1(id){
      this.menu_rankin = id;
      if (id == 1) {
        this.rankin_sub = 'propio_ejecutivo1';  
        this.apibitacora(5);
      }else if(id == 2){
        this.rankin_sub = 'propio_gerente2';  
        this.apibitacora(6);
      }else{
        this.rankin_sub = 'propio_lider2';
        this.apibitacora(7);  
      }
      
      this.$bus.$emit("cambi_fo61", true)
    },
    apibitacora(id){
      var seccion = "";
      switch (id) {
        case 1:
          seccion = 'Líderes - Retail';
        break; 
        case 2:
          seccion = 'Distribuidor - Especialista';
        break;
        case 3:
          seccion = 'KAMs - Especialista';
        break;
        case 4:
          seccion = 'Líderes - Especialista';
        break;
        case 5:
          seccion = 'Ejecutivos - Propio';
        break;
        case 6:
          seccion = 'Puntos de Venta - Propio';
        break;
        case 7:
          seccion = 'Líder interno - Propio';
        break; 
      }
     this.$api.post('auth/bitacora', {
          'correo' : this.user.email,
          'mrt' : this.user.mrt,
          'canal' : this.user.canal,
          'perfil' : "",
          'region' : 'N/A',
          'url' : "/Ranking",
          'seccion' : "",
          'accion' : 'Consulto',
          'detalle' :  'Consulto Ranking ' + seccion,
        }).then(
          response => {
             console.log(response);
          })
    },
    guardaDescarga(){
        this.$api.post('auth/bitacora', {
          'correo' : this.user.email,
          'mrt' : this.user.mrt,
          'canal' : this.user.canal,
          'perfil' : "",
          'region' : 'N/A',
          'url' : "/Ranking",
          'seccion' : "",
          'accion' : 'Descargo',
          'detalle' :  'Descargo tabla de resultados',
        }).then(
          response => {
             console.log(response);
          }) 
    }
  },
  mounted(){ 
     window.AOS.init();  
     setTimeout(() => {
        this.anima = 1; 
            setTimeout(() => {
              this.anima = 0; 
            }, 2500) 
      }, 700) 
  }
}
</script>

<style>
.zoom-in-out-box { 
  animation: zoom-in-zoom-out 7s ease infinite; 
}

@keyframes zoom-in-zoom-out {
  0% {
      transform: scale(1.2); 
  }
  50% {
     transform: scale(1); 
  }
  100% {
      transform: scale(1.2); 
  }
}
</style>